import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/navigation";
import { hideDrawer } from "@app/store/layoutSlice";
import { AppState } from "@app/store/store";
import { ReportWidget } from "@widgets/report-widget";
import { Faq } from "@features/history";
import {
    CheckHistory,
    CheckHistoryBar,
    isValidVinOrPlate,
    mockHistory,
    normalizeHistoryFullReportData,
    normalizeVinOrPlate,
    ReportContent
} from "@entities/history";
import { RouterConfig } from "@shared/lib/routerConfig";
import { Drawer } from "@shared/ui/drawer";
import classes from "./history-screen.module.scss";

export const HistoryScreen = () => {
    const router = useRouter();
    const [vin, setVin] = useState("");
    const [error, setError] = useState(false);
    const dispatch = useDispatch();
    const drawerVisible = useSelector((state: AppState) => state.layout.drawerVisible);

    const handleVinChange = (value: string) => {
        setVin(value.toUpperCase());
        if (error) setError(false);
    };

    const handleVinSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        const value = normalizeVinOrPlate(vin);
        if (!isValidVinOrPlate(value)) {
            setError(true);
            return;
        }

        setError(false);
        router.push(`${RouterConfig.HISTORY}/${value}`);
    };

    return (
        <div className={classes.history}>
            <h1 className={classes.history__title}>Проверьте историю автомобиля</h1>
            <CheckHistory
                vin={vin}
                setVin={handleVinChange}
                error={error}
                onSubmit={handleVinSubmit}
            />
            <ReportContent />
            <Faq />
            <CheckHistoryBar
                vin={vin}
                setVin={handleVinChange}
                error={error}
                onSubmit={handleVinSubmit}
            />
            <Drawer open={drawerVisible} onClose={() => dispatch(hideDrawer())}>
                <ReportWidget report={normalizeHistoryFullReportData(mockHistory)} isSample />
            </Drawer>
        </div>
    );
};